export default __webpack_public_path__ + "a58d4f1b03d6c44783e763485ba7e098.png";